import React, { useEffect, useRef } from 'react';

// Adet/B.Fiyat gibi sayısal hücreleri düzenlemek için küçük popup. Açılınca input focus'lu ve mevcut
// değer tamamen seçili gelir — kullanıcı yazmaya başlayınca eskisi otomatik silinir (kullanıcı talebi:
// 2026-08-08). inputMode sayesinde mobilde sayısal klavye açılır (numerik: 'tam' -> rakam klavyesi,
// 'ondalik' -> virgüllü sayı klavyesi).
export default function SayiDuzenleModal({ baslik, deger, onDeger, onTamam, onKapat, numerik = 'tam' }) {
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
    inputRef.current?.select();
  }, []);

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100 }}>
      <div className="card" style={{ width: 280, maxWidth: '90vw' }}>
        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 10, color: 'var(--med-dark)' }}>{baslik}</div>
        <input
          ref={inputRef}
          type="text"
          inputMode={numerik === 'ondalik' ? 'decimal' : 'numeric'}
          value={deger}
          onChange={onDeger}
          onKeyDown={e => {
            if (e.key === 'Enter') onTamam();
            if (e.key === 'Escape') onKapat();
          }}
          style={{ width: '100%', fontSize: 18, textAlign: 'right', padding: '8px 10px', marginBottom: 14, boxSizing: 'border-box' }}
        />
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button onClick={onKapat} className="btn btn-secondary">Vazgeç</button>
          <button onClick={onTamam} className="btn btn-primary">TAMAM</button>
        </div>
      </div>
    </div>
  );
}
